import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Eyebrow } from "@/components/Motion";

export const PageHero = ({ eyebrow, title, intro, img, testId = "page-hero", children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "18%"]);
  return (
    <section ref={ref} data-testid={testId} className="relative overflow-hidden bg-[#0F2138] pb-16 pt-36 sm:pb-24 sm:pt-44">
      {img && (
        <motion.div style={{ y }} className="absolute inset-0">
          <img src={img} alt="" className="h-full w-full object-cover opacity-35" fetchpriority="high" />
        </motion.div>
      )}
      <div className="absolute inset-0 bg-[#0F2138]/55" aria-hidden="true" />
      <div className="grain" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
        <Eyebrow light>{eyebrow}</Eyebrow>
        <h1 className="mt-6 max-w-4xl font-serif text-4xl font-medium leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <MaskLines lines={[title]} />
        </h1>
        {intro && (
          <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.9 }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-[#C9D4E1] md:text-lg">{intro}</motion.p>
        )}
        {children}
      </div>
    </section>
  );
};
